module.exports = __webpack_public_path__ + "static/media/copy.72f8a374.svg";